export class NpsFactory {
  constructor(instance) {
    this.instance = instance;
  }

  check() {
    return this.instance.get('/v1/nps/check');
  }

  fill(data) {
    return this.instance.post('/v1/nps/fill', data);
  }

  ignore() {
    return this.instance.post('/v1/nps/ignore', {});
  }
}

export default (...params) => new NpsFactory(...params);
